export const locale = {
    lang: 'pl',
    data: {
        "Use": "Zużycie",
        "New": "Nowe",
        "Edit": "Edycja",
        "Add product": "Dodaj produkt",
        "Remove": "Usuń",
        "Save": "Zapisz",
        "Product": "Produkt",
        "Customer": "Klient",
        "Worker": "Pracownik",
        "Unit": "Jednostka",
        "Quantity": "Ilość",
        "Product name": "Nazwa produktu",
        "Created at": "Data dodania",
        "Add use": "Dodaj zużycie",
        "Use history": "Historia zużycia",
        "No.": "Lp.",
        "Use details": "Dane zużycia",
        "Name": "Nazwa",
        "products": "produkty",
        "Details": "Dane"
    }
};
